import OrderModal from './OrderModal';

export * from './types';

export default OrderModal;
